import { useQuery } from '@tanstack/react-query';
import { API_URL } from './constants';
import { authHeaders } from './helpers';
import type { Employee, LoadedData, PayRun, Schedule, StubLine } from './types';

export function usePayRunData(payRunId: string | undefined) {
  return useQuery<LoadedData, Error>({
    queryKey: ['pay-run-full', payRunId],
    enabled: Boolean(payRunId),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const runResp = await fetch(API_URL + '/api/v1/payroll/runs/' + payRunId, { headers: authHeaders() });
      if (!runResp.ok) throw new Error('Could not load pay run (HTTP ' + runResp.status + ')');
      const runData: PayRun = await runResp.json();

      let schedData: Schedule | null = null;
      if (runData.pay_schedule_id) {
        const schedResp = await fetch(
          API_URL + '/api/v1/payroll/schedules/' + runData.pay_schedule_id,
          { headers: authHeaders() },
        );
        if (schedResp.ok) schedData = (await schedResp.json()) as Schedule;
      }

      const empResp = await fetch(API_URL + '/api/v1/payroll/employees', { headers: authHeaders() });
      if (!empResp.ok) throw new Error('Could not load employees');
      const empData = await empResp.json();
      const empArr: Employee[] = Array.isArray(empData) ? empData : (empData.employees || []);

      const linesResp = await fetch(
        API_URL + '/api/v1/payroll/runs/' + payRunId + '/stubs',
        { headers: authHeaders() },
      );
      let lines: StubLine[] = [];
      if (linesResp.ok) {
        const linesData = await linesResp.json();
        lines = Array.isArray(linesData) ? linesData : (linesData.lines || []);
      }

      return { runData, schedData, empArr, lines };
    },
  });
}